/**
 * formatDate：转换为相应格式的日期字符串
 * @param dateinit 13位的时间戳或是日期格式的字符串。必填。
 * @param format 日期格式。默认'yyyy-mm-dd hh:ii:ss'
 * @returns {string} 返回format格式的字符串
 */
export default {
  // 富文本转义字符处理
  showHtml(str){
    return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
        .replace(/&lt;/g,"<")
        .replace(/&gt;/g,">")
        .replace(/&quot;/g,"\"")
        .replace(/&#39;/g, "\'")
        .replace(/&amp;nbsp;/g,'\u3000')
        .replace(/&amp;ldquo;/g, "“")
        .replace(/&amp;rdquo;/g, "”")
        .replace(/\n\n/g, "<br>")
        .replace(/\n/g, "<br>")
  },

  formatDate:function (dateinit, format = "yyyy-mm-dd hh:ii:ss") {
    let format_str = format;
    if (dateinit === null || dateinit === 0 || dateinit === "" || dateinit === undefined) {
      return "";
    }
    let date = new Date(dateinit);
    //若改为let date = new Date(dateinit / 1000);则dateinit参数仅支持10位的时间戳
    let date_str = {
      "y+": date.getFullYear(), //年
      "m+": date.getMonth() + 1, //月份
      "d+": date.getDate(), //日
      "h+": date.getHours(), //小时
      "i+": date.getMinutes(), //分
      "s+": date.getSeconds(), //秒
    };
    for (let item in date_str) {
      if (new RegExp("(" + item + ")", "i").test(format_str)) {
        format_str = format_str.replace(RegExp.$1, date_str[item].toString().length < 2 ? "0" + date_str[item] : date_str[item]);
      }
    }
    return format_str;
  },

  /*判断token是否过期*/
  isTokenExpired() {
    let expiredTime = new Date().getTime();
    /*从localStorage中取出token过期时间*/
    if (localStorage.getItem("expires_in") != undefined && localStorage.getItem("expires_in") != "undefined") {
      expiredTime = Number(localStorage.getItem("expires_at")) // token过期的时间戳
      // expiredTime = new Date(localStorage.getItem("expires_at")).getTime() / 1000
    }
    /*获取本地时间*/
    let nowTime = new Date().getTime()
    // debugger
    /*获取校验时间差*/
    // let diffTime = JSON.parse(sessionStorage.diffTime)
    // let diffTime = 10000;
    /*校验本地时间*/
    // nowTime -= diffTime
    // alert(expiredTime - nowTime);
    /*如果 < 10分钟，则说明即将过期*/
    // console.log(expiredTime,nowTime,expiredTime - nowTime)
    var flag = (expiredTime - nowTime) < 10 * 60;
    // return (expiredTime - nowTime) < 10*60;
    return flag;
  }
}
